<template>
  <div :class="$style.layout">
    <AlertPortal enableAutoHide :class="$style.layout__alert" />
    <main :class="[$style.layout__content, $style.content]">
      <slot />
    </main>
    <AppFooter :class="$style.layout__footer" :fragment="result" />
  </div>
</template>

<script setup lang="ts">
import AppFooter from '@/components/organisms/AppFooter/AppFooter.vue'
import DolphinAlert from '@/components/organisms/DolphinAlert/DolphinAlert.vue'
import { alertPortalize } from '@/libs/alertPortal'

import { useFetchErrorLayoutQuery } from './ErrorLayout.generated'

const AlertPortal = alertPortalize(DolphinAlert)

const { result } = useFetchErrorLayoutQuery()
</script>

<style lang="scss" module>
.layout {
  $root: &;
  $footer-height: 198px;
  $content-side-padding: 40px;
  $min-width: $content-width + ($content-side-padding * 2);
  $min-width-fullbleed: $content-width;

  min-width: $min-width;
  min-height: 100vh;
  background-color: $color-surface-primary;
  transform: translate(0);

  &__alert {
    position: fixed;
    z-index: 2;
    top: 20px;
    right: 20px;
    left: 20px;
    margin: auto;
  }

  &__content {
    $content-min-height: calc(100vh - #{$footer-height});

    min-width: 100%;
    min-height: $content-min-height;
    box-sizing: border-box;
    padding: 32px $content-side-padding;
  }

  &__footer {
    min-width: 100%;
    height: $footer-height;
    box-sizing: border-box;
  }
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
